import { render } from "./VerInvitados.vue?vue&type=template&id=664fd943&scoped=true"
import script from "./VerInvitados.vue?vue&type=script&lang=js"
export * from "./VerInvitados.vue?vue&type=script&lang=js"

import "./VerInvitados.vue?vue&type=style&index=0&id=664fd943&scoped=true&lang=css"

import exportComponent from "/home/sensores-test/frontendv2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-664fd943"]])

export default __exports__